/* eslint-disable @nx/enforce-module-boundaries */
import { Card, Divider, HStack, Heading, Spinner, Stack, Text, Collapse, } from '@mybridge/ui';
import { useRouter } from 'next/router';
import { forwardRef, useContext, useEffect, useState } from 'react';
import { SearchJobCard } from 'v4/components/jobs/search-job-card';
import { JobsListingContext } from 'v4/snippets/jobs/context';
import { SearchContext } from '../context';
import { SearchCardSkeleton } from '../search-card-skeleton';
import { SearchNewJobListing } from './listing';
import { isMobile } from 'react-device-detect';
import { useDisclosure } from '@mybridge/ui';
import { SearchCompanyPagesFilters } from '../pages/filters';
import { IconButton } from '@chakra-ui/react';
import { Filters } from '@mybridge/icons';
import { SearchJobsFilters } from './filters';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useSelector } from 'react-redux';
export const SearchJobsListing = forwardRef(
  ({ count, listing, ...props }, ref) => {
    const { push } = useRouter();
    const {
      jobsSearchListing,
      refetchJobsSearch,
      jobsHasNextPage,
      jobsFetchNextPage,
      jobsSearchIsFetching,
      activeTab,
      query,
      jobsTotalCount,
    } = useContext(SearchContext);
    const { t } = useTranslator();
    const { loggedIn } = useSelector((state) => state.user);
    const filterDisc = useDisclosure();
    const [selected, setSelected] = useState();
    const {
      isSavedJob,
      saveJob,
      saveJobIsLoading,
      removeSavedJob,
      removeSavedJobIsLoading,
      refetchSavedJobsListing,
      refetchAppliedJobsListing,
    } = useContext(JobsListingContext);

    useEffect(() => {
      // refetchSavedJobsListing?.();
      // refetchAppliedJobsListing?.();
      if (loggedIn) {
        refetchSavedJobsListing?.();
        refetchAppliedJobsListing?.();
      }
    // }, []);
    }, [loggedIn]);
    useEffect(() => {
      if (!listing) {
        refetchJobsSearch?.();
      }
    }, [query, listing]);

    const list = listing ?? jobsSearchListing;

    return (
      <Stack>
        {isMobile ? (
        <Collapse style={{overflow:"inherit"}} in={filterDisc?.isOpen} animateOpacity>
          <SearchJobsFilters />
          <Divider my={2} />
        </Collapse>
      ) : (
        ''
      )}
        <Stack spacing={0}>
          <HStack w="100%"
            justifyContent="space-between"
            alignItems="center"
            gap={0}>
            <Heading as="h1" pl={2} fontSize="20px" color="brandPrimary.500" fontWeight="400">{t('pages.jobs') || "Jobs"}</Heading>
            {jobsSearchIsFetching ? <Spinner /> : ''}
            {isMobile && <IconButton icon={<Filters />} onClick={() => filterDisc.onToggle()} variant="transparent" />}
          </HStack>
          {query?.query?.length && jobsTotalCount ? (
            <Text size="sm">{jobsTotalCount} {t('pageJobs.results') || "results"}</Text>
          ) : (
            ''
          )}
        </Stack>
        <SearchNewJobListing />
     
      </Stack>
    );
  }
);
